// src/pages/FacebookActivitiesPage.jsx

import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import FacebookSDKLoader from "../components/FacebookSDKLoader";
import FacebookRawPost from "../components/FacebookRawPost";
import {
  facebookActivitiesPosts,
  buildFacebookPostHtml,
} from "../data/facebookActivitiesPosts";

export default function FacebookActivitiesPage() {
  // --- REACT-SNAP Logic ---
  useEffect(() => {
    if (window.snapSaveState) {
      window.snapSaveState = () => { };
    }

    const timer = setTimeout(() => {
      if (window.snapSaveState) {
        window.snapSaveState = null;
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // ข้อมูลโพสต์ (แนะนำให้เรียงจากใหม่ไปเก่า)
  const posts = facebookActivitiesPosts;
  const { t } = useTranslation();
  const lang = i18n.language || "th";
  const remainingPosts = posts.filter((p) => !p.isFeatured);

  return (
    <div className="min-h-screen bg-[#fcfaf8] text-[#3d342e] flex flex-col font-sans">
      <Helmet>
        <title>{t("facebookActivities.meta.title", { lng: lang })}</title>
        <meta
          name="description"
          content={t("facebookActivities.meta.description", { lng: lang })}
        />
      </Helmet>

      <SiteHeader />

      <main className="flex-1 pt-24 pb-20">
        <FacebookSDKLoader />

        {/* --- Header Section --- */}
        <section className="max-w-7xl mx-auto px-4 mb-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >

            <h1 className="text-3xl md:text-5xl font-bold mb-6 italic leading-tight">
              {t("facebookActivities.hero.title", { lng: lang })}
            </h1>
            <p className="text-[#7b6c61] max-w-2xl mx-auto font-light">
              {t("facebookActivities.hero.description", { lng: lang })}
            </p>
          </motion.div>
        </section>

        <div className="max-w-7xl mx-auto px-4">

          {/* --- Masonry-style Grid --- */}
          <section className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
            {remainingPosts.map((p) => (
              <motion.div
                key={p.id}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                className="break-inside-avoid bg-white rounded-2xl p-4 shadow-md border border-[#f1e6da] hover:shadow-lg transition-shadow"
              >
                <FacebookRawPost html={buildFacebookPostHtml(p.href)} />
              </motion.div>
            ))}

            {/* CTA Card แทรกใน Grid */}
            <div className="break-inside-avoid bg-[#5b4a3e] rounded-2xl p-8 text-white flex flex-col items-center text-center shadow-lg">

              <h3 className="text-xl font-bold mb-2">
                {t("facebookActivities.cta.title", { lng: lang })}
              </h3>
              <p className="text-white/70 text-sm mb-6 font-light">
                {t("facebookActivities.cta.description", { lng: lang })}
              </p>
              <a
                href="https://www.facebook.com/nl.chiangmai"
                target="_blank"
                rel="noreferrer"
                className="bg-[#d8653b] hover:bg-[#c25a34] text-white px-6 py-2 rounded-full text-sm font-bold transition-colors"
              >
                {t("facebookActivities.cta.button", { lng: lang })}
              </a>
            </div>
          </section>
        </div>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}